import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    loadingMounted: false
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/shared/index.js